export class ConversionTableImportData {
    ConversionTableId: number;
    PartnerId?: number;
    Delimiter: string;
    DataToImport: string;
}